<template>
  <div
    class="container-fluid"
    style="display: flex;
    display: -webkit-flex; /* Safari */
    height:100%;
    min-height: 100vh;
    flex-direction: column;">
    <MyHeader/>
    <router-view/>
    <MyFooter/>
  </div>

</template>

<script>
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import MyHeader from '@/views/contents/components/MyHeader.vue'
import MyJumbotron from '@/views/contents/components/MyJumbotron.vue'
import MyCarousel from '@/views/contents/components/MyCarousel.vue'
import MyFooter from '@/views/contents/components/MyFooter.vue'

export default {
  name: 'IndexPage',

  components: {
    MyHeader,
    MyJumbotron,
    MyCarousel,
    MyFooter
  }
}
</script>

<style lang="scss" >
.container-fluid, .container-sm, .container-md, .container-lg, .container-xl {
    width: 100%;
    padding-right: 0px;
    padding-left: 0px;
    margin-right: auto;
    margin-left: auto;
}

.container{
    width: 100%;
    padding-right: 15px;
    padding-left: 15px;
    margin-right: auto;
    margin-left: auto;
}
</style>

